import { useLayoutEffect } from 'react';

export const useOnResize = (callback: () => unknown) => {
    useLayoutEffect(() => {
        globalThis.addEventListener('resize', callback);

        return () => globalThis.removeEventListener('resize', callback);
    }, [callback]);
};
